import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import {push} from '../../core/redux/router'
import {matchMedia} from '../../core/browser'
import {loadCampaignStream} from '../actions'
import CampaignCard from './CampaignCard'

const PAGE_SIZE = 20

class CampaignStream extends Component {
    static propTypes = {
    }

    _navigate(event, campaign) {
        const {dispatch} = this.props

        event.preventDefault()

        if (event.ctrlKey || event.metaKey) {
            window.open(resolveLocationPathname('/*/*/satisfactioncampaigns/' + campaign.uid), '_blank')
        } else {
            dispatch(push('/*/*/satisfactioncampaigns/' + campaign.uid))
        }
    }

    render() {
        const {dispatch, stream} = this.props

        return (
            <div>
                <Row>
                {stream.map((campaign) => (
                    <Col
                        key={campaign.uid}
                        sm={6}>
                        <CampaignCard
                            campaign={campaign}
                            onClick={(e) => this._navigate(e, campaign)} />
                    </Col>
                ))}
                </Row>
            </div>
        )
    }
}

CampaignStream = connect((state) => ({
    stream: state.satisfaction.campaign.stream
}))(CampaignStream)

export default CampaignStream


// WEBPACK FOOTER //
// ./lib/satisfaction/components/CampaignStream.js